import {Component,OnInit,ViewChild} from '@angular/core';
import {ListView,TypeComparaison,TypeFilter} from "@domain/common/list-view";
import {Tolerance} from '@domain/typecharge/tolerance';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@environments/environment';
import {Sorting} from '@domain/common/list-view/sorting';
import {ListViewComponent} from '@share/component/list-view/list-view.component';
import {FacturesTolerancesItemComponent} from "@components/admin/frais/factures/tolerances/tolerances-item/factures-tolerances-item.component";

/**
 * Onglet factures tolérances
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'factures-tolerances'},
    templateUrl: './factures-tolerances.component.html'
})
export class FacturesTolerancesComponent implements OnInit {
    /** Liste view des tolérances */
    toleranceListView: ListView<Tolerance, FacturesTolerancesItemComponent>;

    /** Composant de liste */
    @ViewChild('listeFacturesTolerances') listeFacturesTolerances: ListViewComponent<any,any>;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     */
    constructor(
        public translateService: TranslateService
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Initialisation de la liste view
        this.toleranceListView = new ListView<Tolerance, FacturesTolerancesItemComponent>({
            component: FacturesTolerancesItemComponent,
            uri: `${environment.baseUrl}/controller/tolerances/listeTolerance`,
            title: this.translateService.instant('admin.frais.tolerances.title'),
            defaultOrder: 'libelle',
            listeFilters: [{
                clef: 'libelle',
                title: this.translateService.instant('admin.frais.tolerances.filtres.libelle'),
                type: TypeFilter[TypeFilter.STRING],
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: true
            }, {
                clef: 'active',
                title: this.translateService.instant('admin.frais.tolerances.filtres.actif'),
                type: TypeFilter[TypeFilter.BOOLEAN],
                typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                isDefault: false
            }],
            isFilter: true
        });

        //Définition des colonnes de tri
        this.toleranceListView.columns = [
            {key: 'libelle', title: this.translateService.instant('admin.frais.tolerances.filtres.libelle')},
            {key: 'active', title: this.translateService.instant('admin.frais.tolerances.filtres.actif')}
        ];

        //Ajout du tri de la liste selon l'ordre voulu
        this.toleranceListView.sorting = new Sorting(
            this.toleranceListView.columns,
            'libelle'
        );

        //Nom de la classe
        this.toleranceListView.className = "factures-tolerances";

        //Persistence des filtres
        this.toleranceListView.isPersistFilters = true;
    }
}
